module.exports = __webpack_public_path__ + "static/media/newfield.daabc22d.svg";